import {useEffect} from 'react'

import {useAppSelector} from '../../../../../hooks/react-redux'
import {useBooleanQueryParamState} from '../../../../../hooks/routes'
import ConfigurationStorageDialog from '../../components/ConfigurationStorageDialog/ConfigurationStorageDialog'
import {useBanners} from '../../contexts/Banners/BannersContext'
import {MessageType, VALIDATION_ERRROR_MESSAGE} from '../../contexts/Banners/BannersContext.types'
import {usePipelineId} from '../../hooks/pipeline'
import {useConfigurationStorage} from '../EditPipelinePage.hooks'

function EditPipelineConfigurationDialog() {
  const id = usePipelineId()

  const {dialogVisible, isLoading, onConfigurationStorageChange} = useConfigurationStorage()
  const [_, setIsYaml] = useBooleanQueryParamState('yaml')
  const isParsed = useAppSelector(state => state.pipelines.pipelineYamlValidity[id]?.isParsed)
  const {addBanner} = useBanners()

  useEffect(() => {
    if (isParsed != null && !isParsed) {
      setIsYaml(true)
      addBanner(id, {
        key: `${id}-${VALIDATION_ERRROR_MESSAGE}`,
        type: MessageType.INFO,
        message:
          'The Pipelines project loaded from the YAML configuration file that contains errors. The Visual editor is disabled until these issues are resolved.',
      })
    }
  }, [addBanner, id, isParsed, setIsYaml])

  return (
    <ConfigurationStorageDialog
      isCreationMode
      isLoading={isLoading}
      visible={dialogVisible}
      onConfirm={onConfigurationStorageChange}
    />
  )
}

export default EditPipelineConfigurationDialog
